import { api } from './client';
import type { DocumentSerialDto, CreateDocumentSerialRequest, UpdateDocumentSerialRequest } from '../types/documentSerial';

export interface DocumentNumberPreview {
  nextNumber: string;
  nextSequence: number;
}

export interface PatternPreviewResult {
  sampleNumber: string;
  containsDateTokens: boolean;
  containsPrefixToken: boolean;
  sequencePadding: number;
}

export interface PatternDetectionResult {
  detectedPrefix: string;
  detectedPadding: number;
  samplePattern: string;
  suggestedPattern: string;
}

export const documentSerialsApi = {
  list: () =>
    api.get<DocumentSerialDto[]>('/document-serials'),

  getById: (id: number) =>
    api.get<DocumentSerialDto>(`/document-serials/${id}`),

  create: (data: CreateDocumentSerialRequest) =>
    api.post<number>('/document-serials', data),

  update: (id: number, data: UpdateDocumentSerialRequest) =>
    api.put<void>(`/document-serials/${id}`, data),

  delete: (id: number) =>
    api.delete<void>(`/document-serials/${id}`),

  preview: (id: number, date?: string) =>
    api.get<DocumentNumberPreview>(`/document-serials/${id}/preview`, { date }),

  previewPattern: (data: { pattern: string; prefix?: string; sequenceNumber: number; date?: string }) =>
    api.post<PatternPreviewResult>('/document-serials/preview-pattern', data),

  detectPattern: (existingNumbers: string[]) =>
    api.post<PatternDetectionResult>('/document-serials/detect-pattern', { existingNumbers }),
};
